import $ from 'jquery'
import Flickity from 'flickity'
import SmoothScroll from 'smooth-scroll'
import { getSreenSizes } from '../util'

const Blog = (() => {
  const initSocials = () => {
    const socials = document.querySelector('.js-socials')
    if (!socials) return

    $('.js-socials').jsSocials({
      shares: [
        {
          share: 'twitter',
          label: 'Twitter',
          hashtags: 'wtafunctionaltraining,functionaltraining',
          logo: '/images/socials/twitter.png'
        },
        {
          share: 'facebook',
          label: 'Facebook',
          logo: '/images/socials/facebook.png'
        },
        {
          share: 'linkedin',
          label: 'Linkedin',
          logo: '/images/socials/linkedin.png'
        }
      ],
      showCount: false,
      showLabel: false,
      shareIn: "popup",
    })
  }

  const initSlider = () => {
    const slider = document.querySelector('.js-blog-slider')
    if (!slider) return

    const fly = new Flickity(slider, {
      cellSelector: '.js-blog-slider-slide',
      cellAlign: 'left',
      pageDots: false,
      freeScroll: false,
      prevNextButtons: false,
      wrapAround: false,
      draggable: true,
    })

    const next = document.querySelector('.js-blog-slider-next')
    next.addEventListener('click', (e) => {
      e.preventDefault()

      fly.next()
    })
  }

  const initSidebar = () => {
    const sidebar = document.querySelector('.js-blog-sidebar')
    const sidebarButton = document.querySelector('.js-blog-sidebar-button')
    const sidebarClose = document.querySelector('.js-blog-sidebar-close')
    if (!sidebar || !sidebarButton || !sidebarClose) return

    sidebarButton.addEventListener('click', () => {
      sidebar.classList.add('is-active')
    })

    sidebarClose.addEventListener('click', () => {
      sidebar.classList.remove('is-active')
    })
  }

  const initSidebarFixed = () => {
    const screenWidth = getSreenSizes().width
    if (screenWidth <= 768) return

    const sidebar = document.querySelector('.js-sidebar')
    const sidebarMain = document.querySelector('.js-sidebar-main')
    const readBar = document.querySelector('.js-readbar')
    if (!sidebar || !sidebarMain) return

    const headerHeight = document.querySelector('.c-nav').clientHeight

    const rect = sidebar.getBoundingClientRect()
    const top = rect.top + window.pageYOffset
    const height = rect.height
    const rectM = sidebarMain.getBoundingClientRect()
    const topM = rectM.top + window.pageYOffset
    const heightM = rectM.height

    window.addEventListener('scroll', (e) => {
      const scroll = window.pageYOffset
      if (scroll + headerHeight <= top) {
        sidebar.removeAttribute('style')
        sidebar.classList.remove('is-padded')
      } else if (scroll + headerHeight > top && scroll + headerHeight < topM + heightM - height) {
        let left = '2.5%'
        if (screenWidth > 1326) {
          left = `${(screenWidth - 1260) / 2}px`
        }

        sidebar.setAttribute('style', `position: fixed; top: ${headerHeight}px; left: ${left};`)
        sidebar.classList.add('is-padded')
      } else {
        sidebar.setAttribute('style', 'position: absolute; top: initial; bottom: 0; left: 0;')
        sidebar.classList.remove('is-padded')
      }

      // Codice usato per la readBar di lettura
      if (scroll > topM) {
        const readed = scroll - topM
        const total = heightM - headerHeight
        let percentage = readed * 100 / total
        if (percentage < 0) percentage = 0
        if (percentage > 100) percentage = 100
        readBar.style.width = `${percentage}%`
      }
    })
    
  }

  const initReplyButton = () => {
    const replyButtons = document.querySelectorAll('.js-blog-reply')

    replyButtons.forEach((replyButton) => {
      replyButton.addEventListener('click', (e) => {
        e.preventDefault()

        const commentId = replyButton.getAttribute('href').slice(1)
        const name = replyButton.getAttribute('data-name')
        
        const flag = document.querySelector('.js-blog-reply-flag')
        const flagName = flag.querySelector('span')
        flagName.innerHTML = name
        flag.classList.add('is-active')

        const input = document.querySelector('.js-blog-reply-comment')
        input.value = commentId

        const scroll = new SmoothScroll()
        scroll.animateScroll(
          flag,
          null,
          { offset: 300, speed: 1000 }
        )
      })
    })
  }

  const init = () => {
    initSocials()
    initSlider()
    initSidebar()
    initSidebarFixed()
    initReplyButton()
  }

  return {
    init,
  }
})()

export default Blog



// WEBPACK FOOTER //
// app/javascript/scripts/components/Blog.js